var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        [
          _c(
            "v-btn-toggle",
            {
              attrs: { group: "", dense: "" },
              model: {
                value: _vm.loadDuration,
                callback: function ($$v) {
                  _vm.loadDuration = $$v
                },
                expression: "loadDuration",
              },
            },
            [
              _c("v-btn", { attrs: { value: false } }, [_vm._v(" Profile ")]),
              _c("v-btn", { attrs: { value: true } }, [
                _vm._v(" Load Duration Curve "),
              ]),
            ],
            1
          ),
          _vm.chartData
            ? _c("PlotlyWrapper", {
                attrs: { data: _vm.chartData, layout: _vm.chartLayout },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }